export const HomeIndex = () => {
  return (
    <div className="container py-5">
      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <h1 className="display-4 fw-bold mb-3">Plan Your Perfect Trip</h1>
          <p className="lead mb-4">
            ChyTrips is your all-in-one trip planning companion. Create detailed
            itineraries, collaborate with friends, and organize every aspect of your
            journey from flights to activities and accommodations.
          </p>
          <a href="/users/sign_up" className="btn btn-primary btn-lg me-2">
            Start Planning
          </a>
        </div>
        <div className="col-md-6 text-center">
          <img
            src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
            alt="Travel Planning"
            className="img-fluid rounded shadow"
          />
        </div>
      </div>

      <div id="features" className="row text-center mb-5">
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Smart Trip Planning</h5>
              <p className="card-text">
                Create comprehensive trip itineraries with dates, activities, and detailed
                planning. Our calendar view makes it easy to organize your entire journey.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Collaborate with Friends</h5>
              <p className="card-text">
                Share your trips with friends and family. Let them contribute ideas, vote
                on activities, and help plan the perfect adventure together.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Complete Travel Management</h5>
              <p className="card-text">
                Track flights, accommodations, activities, and even weather. Everything
                you need to plan and organize your trip in one place.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section className="p-5 bg-light rounded">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h2 className="fw-bold mb-3">Ready to Start Your Adventure?</h2>
            <p className="mb-4">
              Join thousands of travelers who use ChyTrips to plan their perfect trips.
              From weekend getaways to epic international adventures, we've got you
              covered.
            </p>
          </div>
          <div className="col-md-4 text-md-end text-center">
            <a href="/users/sign_up" className="btn btn-primary btn-lg">
              Start Planning Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
